import { generatePath, useParams } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetOptionI18nParams = () => {
	const { hotelID, optionID, langCode } =
		useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.I18N>>();

	if (!hotelID || !optionID || !langCode) {
		throw Error("error");
	}

	const navigator = {
		default: generatePath(PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.DEFAULT, { hotelID, optionID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.I18N, { hotelID, optionID, langCode }),
	};

	const activeLangCode = langCode as LangCode;

	return {
		hotelID: hotelID,
		optionID,
		activeLangCode,
		navigator,
	};
};
